<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t('view')}} {{$tc('client', 1)}}</div>
      <router-link
        class="btn-blue"
        :to="{path:'clients'}"
      >{{ $tc('clients', 1)}} {{ $tc('list', 1)}}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('client_name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.client_name}}</span>
          </div>
        </div>
      </div>
      <!-- DESC -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('client_description') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.client_description}}</span>
          </div>
        </div>
      </div>
      <!-- PERSON -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('client_contact_person_name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.client_contact_person_name}}</span>
          </div>
        </div>
      </div>
      <!-- //EMAIL -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('client_contact_person_email_id') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.client_contact_person_email_id}}</span>
          </div>
        </div>
      </div>
      <!-- //PHONE -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('client_contact_person_mobile_number') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.client_contact_person_mobile_number}}</span>
          </div>
        </div>
      </div>
      <!-- created_at -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.created_by}}</span>
          </div>
        </div>
      </div>
      <!-- //created_at -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.created_at | dateparse }}</span>
          </div>
        </div>
      </div>
      <!-- updated_by -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('modifiedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.updated_by}}</span>
          </div>
        </div>
      </div>
      <!-- //updated_at -->
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('modifiedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.updated_at | dateparse }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('active') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{client.client_is_active ? 'Yes' :'No'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientService from "@/services/ClientService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      client: {
        client_id: null,
        client_name: null,
        client_description: null,
        client_contact_person_name: null,
        client_contact_person_email_id: null,
        client_contact_person_mobile_number: null,
        client_address: null,
        client_is_active: true,
        created_at: null,
        created_by: null,
        updated_at: null,
        updated_by: null
      }
    };
  },
  beforeMount() {
    this.client.client_id = this.$route.query.client_id;
    if (this.client.client_id) {
      this.getClientDetails(this.client.client_id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getClientDetails: function(client_id) {
      ClientService.GetSingleClientDetails({ client_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.client = obj;
            this.client.client_is_active == "Y" ? true : false;
            Object.keys(obj).map(x => {
              if (x === "created_by") {
                this.getViewUsersDetails(obj[x], "created_by");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(obj[x], "updated_by");
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.client[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    }
  }
};
</script>

    



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ClientComponent/viewClient.vue